export enum MgItemTabs {
  PRODUCT_INFORMATION = 'PRODUCT_INFORMATION',
  PACKAGING = 'PACKAGING',
  ASSORTMENTS = 'ASSORTMENTS',
  PRICES = 'PRICES',
  COMPETITOR_PRICES = 'COMPETITOR_PRICES',
  DOCUMENTATION = 'DOCUMENTATION',
  ENVIRONMENTAL = 'ENVIRONMENTAL',
  JSON = 'JSON',
}
